import { Divider, Form } from 'antd';
import styled from 'styled-components';

export const Wrap = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  max-width: 800px;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
  input#register_emailBaseUrl {
    font-size: 14px;
  }
`;
export const ForgetRuleContentWrap = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  .af-superadmin-setting-forgot-rule-content-wrap {
    width: 50%;
  }
  .af-superadmin-domain-setting-forgot-rule-content-wrap {
    width: 50%;
  }
`;

export const TableWrap = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;

  @media screen and (max-width: 850px) {
    flex-direction: column;
    gap: 0px;
  }
  .noheader {
    @media screen and (max-width: 850px) {
      display: none;
    }
  }
`;
export const TableContainer = styled.div`
  width: 100%;
  .ant-form-item {
    margin: 0px;
  }
  @media screen and (max-width: 767px) {
    width: 100%;
  }
  .custom-table {
    width: 100%;
    border-collapse: collapse;
  }
  .custom-table th,
  .custom-table td {
    padding: 8px;
    border: 1px solid #ddd;
    text-align: left;
    width: calc(100% / 3);
  }

  .custom-table th {
    background-color: #f2f2f2;
  }

  .custom-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  .custom-table tbody tr:hover {
    background-color: #e6e6e6;
  }
`;

export const ContentWrapper = styled.div`
  background-color: var(--white-color);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 5px 11px rgba(0, 0, 0, 0.08);
  padding: 5px 20px;
  margin-bottom: 10px;
  border-radius: 5px;
  .wrapextend {
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
    column-gap: 28px;
  }
`;
export const ButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px;
  .ant-form-item {
    margin: 0px;
  }
`;
export const BaseurlPop = styled.div`
  .ant-tooltip-placement-top.ant-tooltip-inner {
    background-color: var(--white-color);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 5px 11px rgba(0, 0, 0, 0.08);
    width: 30em;
    color: var(--black-color);
  }
`;
export const FormWrap = styled.div`
  max-width: 800px;
  background-color: var(--white-color);
`;
export const RuleWrap = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const LinkSystemWrap = styled.div`
  display: flex;
  gap: 10px;
  .af-superadmin-setting-forgot-rule-linksystem-icon-info,
  .af-superadmin-domain-setting-forgot-rule-linksystem-icon-info {
    transform: scale(0.9);
  }
  .ant-tooltip-inner {
    background-color: #ffff !important;
    color: #000 !important;
  }
`;
export const InfoBox = styled.div`
  background: #f9f9f9;
  padding: 16px;
  font-size: 16px;
  display: flex;
  gap: 5px;
  color: #333;
  .return-to-source-info-message-eg2 {
    white-space: pre;
  }
`;
export const InfoBoxContent = styled.div`
  p {
    margin: 0 0 8px;
  }
  p:last-child {
    margin-bottom: 0;
  }
`;

export const InfoIconWrapper = styled.div`
  width: 35px;
  height: 35px;
  padding: 4px;
`;
export const PLusSymbol = styled.div`
  font-size: 26px;
  color: green;
  font-weight: bolder;
  position: relative;
  top: -0.3em;
  margin: 0px 30px;
`;
export const MiniInputWrap = styled.div`
  display: flex;
  gap: 15px;
  width: 100%;
`;
export const FormLabel = styled(Form.Item)`
  #isPrimaryDomain_isPrimaryDomain_extra {
    color: #0c5992;
  }
  .ant-form-item-label > label {
    font-size: 16px !important;
  }
  &.formItemEvenLine .ant-form-item-label label {
    text-align: inherit !important;
    min-width: 150px !important;
  }
  &.formItemContentWidth {
    .ant-form-item-control-input-content {
      min-width: 350px;
      width: 100%;
    }
  }
`;
export const HeadingColumn = styled.td`
  padding: 0px !important;
  border: none !important;
`;
export const HeadingData = styled.h4`
  padding-left: 5px;
  margin: 10px;
`;
export const FormDivider = styled(Divider)`
  &.ant-divider.ant-divider-vertical {
    border-inline-start: 1px solid var(--bg-dark-green-color);
    height: 5em;
    top: -2em;
    padding-bottom: 20px;
    @media screen and (max-width: 575px) {
      top: 0em;
    }
  }
`;
